import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import clsx from 'clsx'
import { CONSTS } from 'config/objectConst'
import { useMemo } from 'react'
import { useMenuPopup } from 'shared/hooks'
import { typo } from 'shared/styles'

import type { Action } from './utils/actions'

import PlusIcon from '../../../assets/image/icons/svg/icons/Plus2.svg'
import css from './ActionSelect.module.scss'

export function ActionSelect({
	actions,
	actionsList,
	onChange
}: {
	actions: Action[]
	actionsList: any[]
	onChange: any
}) {
	const menu = useMenuPopup()

	const filteredList = useMemo(
		() =>
			actionsList.filter(
				el =>
					el.name === CONSTS.AVAILABLE_ACTIONS.Message.Title ||
					el.name === 'Endorse a skill' ||
					el.name === CONSTS.AVAILABLE_ACTIONS.Connect.Title
			),
		[actionsList]
	)

	const isMenuItemDisabled = (item: Action) =>
		!item.localeAvailable ||
		(item.name === CONSTS.AVAILABLE_ACTIONS.Connect.Title &&
			filteredList.length > 0)

	return (
		<>
			<button
				aria-controls={menu.menuCn}
				aria-expanded={menu.isOpen}
				aria-haspopup='true'
				className={clsx(
					'select chose-action',
					css.trigger,
					menu.isOpen && css.active,
					typo.buttonSmB
				)}
				id={menu.triggerCn}
				onClick={event => {
					menu.openMenu(event)
					localStorage.setItem('2.3', 'true')
				}}
				type='button'
			>
				<img alt='PlusIcon' className='event-action-add__icon' src={PlusIcon} />
				<span>
					{actionsList.length === 0 ? 'Add action' : 'Add next action'}
				</span>

				<span className='field-arrow-icon' />
			</button>

			<Menu
				anchorEl={menu.anchorEl}
				classes={{
					paper: css.wrapper
				}}
				id={menu.menuCn}
				MenuListProps={{
					'aria-labelledby': menu.triggerCn
				}}
				onClose={menu.closeMenu}
				open={menu.isOpen}
			>
				{actions
					.filter(el => el.available)
					.map((action, index) => {
						const isDisabled = isMenuItemDisabled(action)

						return (
							<MenuItem
								className={isDisabled ? 'select-item-disabled' : 'select-item'}
								disabled={isDisabled}
								key={index + 1}
								onClick={() => {
									onChange(action)
									menu.closeMenu()
								}}
								value={action.name}
							>
								{action.name}
							</MenuItem>
						)
					})}
			</Menu>
		</>
	)
}
